/**
 * @generated SignedSource<<d820b086d4cf1cb12ee0335700a66d33>>
 * @relayHash 4fbd860d4d6da48d54a328b64149e3bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 268b2a62b6cf4cee678c07c4bdbd3f41e88e3c16fe516a9c329fed07a193a565

import type { ConcreteRequest } from 'relay-runtime';
export type templateResolverQuery$variables = {
  sortingScheme: string;
  spaceKey: string;
};
export type templateResolverQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly contentBlueprintId: string | null;
      readonly darkModeIconURL: string | null;
      readonly description: string | null;
      readonly iconURL: string | null;
      readonly name: string | null;
      readonly templateId: string | null;
    } | null> | null;
  } | null;
};
export type templateResolverQuery = {
  response: templateResolverQuery$data;
  variables: templateResolverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortingScheme"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "sortingScheme",
        "variableName": "sortingScheme"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "templateId"
          },
          {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
          },
          {
            "kind": "ScalarField",
            "name": "iconURL"
          },
          {
            "kind": "ScalarField",
            "name": "darkModeIconURL"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "templateResolverQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "templateResolverQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4fbd860d4d6da48d54a328b64149e3bf",
    "id": "268b2a62b6cf4cee678c07c4bdbd3f41e88e3c16fe516a9c329fed07a193a565",
    "metadata": {},
    "name": "templateResolverQuery",
    "operationKind": "query",
    "text": "query templateResolverQuery($spaceKey:String!,$sortingScheme:String!){allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme){nodes{name,description,templateId,contentBlueprintId,iconURL,darkModeIconURL}}}"
  }
};
})();

(node as any).hash = "2ea84112b2cb458fa4b2fa24c60d9b43";

export default node;
